import React, { Component } from "react";
import classes from "./SignAgency.css";
import global from "../../global.css";
import SignFirtOne from "../../assets/girlSign.png";
import form from "../../assets/FORMIMAGESIGN.png";
import mobile from "../../assets/SIGNIMAGE.png";
import SignFrom from "./SignFrom/SignFrom";

class SignAgency extends Component {
  state = {
    RightNowPart: 1
  };

  render() {
    return (
      <div className={classes.BackColor}>
        <div className={classes.Background}>
          <div className={global.Responsive} onWheel={this.onMouseWheel}>
            <div className={classes.partOne}>
              <img
                src={SignFirtOne}
                alt="تصویر SIGN"
                className={classes.SignFirtOne}
              />
              <div>
                <h2>
                  قوانین و مقررات حساب کاربری
                  <br />
                  رزرواسیون محراب سیر کیش
                </h2>
                <p>
                  برای خرید آنلاین بلیت از سیستم رزرواسیون محراب سیر کیش لازم
                  نیست که حساب کاربری داشته باشید. با این وجود داشتن یک حساب
                  کاربری به خاطر مزایایی که دارد، به طور کلی به همهٔ همکاران
                  توصیه می‌شود. جهت استفاده از Sign فوق، لطفا به قسمت رزرواسیون
                  سایت مراجعه نمایید.
                  <br />
                  این Sign متعلق به آژانس درخواست کننده می باشد و هرگونه عواقب
                  ناشی از سوءاستفاده کارکنان از این اطلاعات بر عهده آژانس
                  درخواست کننده خواهد بود.
                  <br />
                  جهت امنیت بیشتر، رمز عبور خود را هر ماه یک بار تغییر دهید.
                  لطفاً از دریافت بیشتر از یک sign برای نماینده جداً خودداری
                  فرمایید. مسئولیت صحت تمامی اطلاعات وارد شده به عهده آژانس
                  درخواست کننده می باشد.
                </p>
                <a className={global.button} href="#FormPart">
                  ثبت درخواست
                </a>
              </div>
            </div>
            <div className={classes.partOne}>
              <img
                src={form}
                alt="تصویر SIGN"
                className={classes.SignFirtOne}
              />
              <div>
                <h2>مزایای داشتن حساب کاربری</h2>
                <p>
                  وقتی شما برای خودتان یک حساب کاربری بسازید نام کاربری دلخواه
                  خودتان را انتخاب میکنید ( البته به شرط آن که قبلاً توسط دیگری
                  ثبت نشده باشد ) به این ترتیب، پس از ورود به سامانه، تمام
                  فعالیت که انجام میدهید به نام شما ثبت خواهد شد. سپس شما
                  میتوانید گزارش تمام فعالیتهایی که در محراب سیر کیش داشته اید
                  مثل زمان خرید بلیت، رفرنس، واچر، نام مسافر، شماره بلیت و
                  همچنین گزارش استرداد بلیت های خریداری شده را از طریق صفحهٔ های
                  مرتبط بررسی کرده و در انتها نام تجاری خود را بروی بلیت خریداری
                  شده جهت ارائه به مسافران خود درج کنید.
                </p>
                <p dir="ltr" style={{ fontFamily: "iransB" }}>
                  021-88749888
                </p>
                <p dir="ltr">
                  <b>sign@mehrabgasht.com</b>
                </p>
                <p>مسئول مستقیم حساب کاربری رزرواسیون</p>
                <p>آقای گلستانی</p>
                <p>داخلی 206</p>
              </div>
            </div>
            <div
              id="FormPart"
              className={[classes.partFrom, classes.FormPart].join(" ")}
            >
              <img
                src={mobile}
                alt="تصویر SIGN"
                className={classes.SignFirtOne}
              />
              <div>
                <h2>درخواست ایجاد حساب کاربری</h2>
                <SignFrom />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignAgency;
